import { Component, Input, OnInit } from '@angular/core';
import { DateService } from '../service/date.service';
import * as title from './../../../../data/title.json';

@Component({
  selector: 'ngx-stickers-print',
  templateUrl: './stickers-print.component.html',
  styleUrls: ['./stickers-print.component.scss']
})
export class StickersPrintComponent implements OnInit {

  @Input() regNum:number;
  @Input() copies:number[];
  @Input() data:any;
  @Input() selectedType:string;
  @Input() stickerType:string;
  @Input() from:string;
  @Input() imageSrc:string;
  styleUrl="";
  //[styleSheetFile]="styleUrl"
  IP:boolean=false;

  @Input() admissionNum:any;
  titleList: any = (title as any).default;
  constructor(public dateService:DateService) { }

  ngOnInit(): void {
    var x = this.data;
    if(this.from == 'IP'){
      this.IP = true;
    }
    else{
      this.IP = false;
    }
  }
  getPatientTitle(data){
    return this.titleList.find(e=>e.value==data)?.title;
  }
  getPatientName(firstname:string,middlename:string,lastname:string):string{
    let fullname:string='';
    if(!!firstname){
      fullname=firstname
    }
    if(!!middlename){
      fullname+=" "+middlename
    }
    if(!!lastname){
      fullname+=" "+lastname
    }
    return fullname
}
}
